<template lang="pug">
  el-dialog(:title="$t(isEditing?'Cuona.Event.change':'Cuona.Event.new')" width="65%" top="8vh" :visible="isShowingDialog" @closed="dialogClosed" @close="hideDialog")
    el-form(label-position="left" :rules="rules" label-width="140px" ref="dialogForm" :model="dialogForm" v-loading="isLoadingEvent")
      el-form-item(:label="$t('Cuona.Event.name')" prop="name")
        el-input(v-model="dialogForm.name")
      el-form-item(:label="$t('Cuona.Event.action')" prop="actionType")
        el-select.action(v-model="dialogForm.actionType" :placeholder="$t('Cuona.Event.choice')" :disabled="isEditing")
          el-option(v-for="action in availableActions" :label="$t(action.name)" :value="action.type" :key="action.type")
        el-popover(placement="right" :title="setActionTitle()" width="200" trigger="hover" :content="setContent()")
          el-button.question(slot="reference" type="text")
            i.el-icon-question
      el-form-item(:label="$t('WebHook.enabled')" v-if="dialogForm.actionType==='checkin' || dialogForm.actionType==='checkout'")
        el-switch(v-model="webhookSettings.enabled")
      //- URL
      el-form-item(v-if="dialogForm.actionType==='public_url' || dialogForm.actionType==='custom_url'" :label="$t('Cuona.Event.url_txt')")
        el-row(type="flex" justify="space-between")
          el-col(:span="20")
            el-input(v-model="dialogForm.actionData.url" :placeholder="$t('Cuona.Event.placeholderUrl')")
          el-row(:span="8")
            el-button(@click="insertDeviceId" :disabled="checkUrlLength()") 固有IDを挿入
      //- WebHook
      web-hook-setting-form(v-if="webhookSettings.enabled" v-model="webhookSettings")
      //- Note入力
      el-form-item(:label="$t('Cuona.Event.note')")
        el-input(type="textarea" :rows="2" v-model="dialogForm.description")
      //- 設定Group選択
      el-form-item(:label="$t('Cuona.Event.group')" prop="group")
        el-select.group-select(v-model="dialogForm.selectedGroupIds" :placeholder="$t('Cuona.Event.choice')" multiple="")
          el-option(v-for="(group, index) in groups" :label="group.name" :value="group.id" :key="index")
      //- CUONA一覧
      el-form-item(label="CUONA")
        .content
          el-table(ref="groupDeviceTable" :data="devices" @row-click="toggleDevice" @selection-change="setSelectedDevices"
              cell-class-name="el-table-cell" row-class-name="el-table-row" max-height="300" empty-text="")
            el-table-column(type="selection" width="55")
            el-table-column(prop="name" :label="$t('Cuona.Device.name')" sortable="")
              template(slot-scope="props")
                img.device-image(:src="getCuonaImage(props.row)")
                span {{ props.row.name }}
            el-table-column(width="180px" prop="nfc_uid" :label="$t('Cuona.Device.id')" sortable="")
            el-table-column(prop="groups" :label="$t('Cuona.Event.group')" sortable="")
              template(slot-scope="props")
                template(v-for="group in props.row.groups")
                  el-tag.tag(size="mini") {{ group.name }}
    span.dialog-footer(slot="footer")
      el-button(@click="hideDialog" :disabled="isLoadingEvent") {{ $t('Cuona.Event.cancel') }}
      el-button(type="primary" @click="createUpdateEvent" :disabled="isLoadingEvent") {{ $t(isEditing?'Cuona.Event.update':'Cuona.Event.create') }}
</template>

<script>
  import actions from '@/utils/defines/actions.js';
  import EventApi from '@/api/event';
  import GroupApi from '@/api/group';
  import DeviceApi from '@/api/cuona';
  import PluginApi from '@/api/plugin';
  import WebHookSettingForm from "./WebHookSettingForm";
  export default {
    mixins: [actions],
    components: {
      'web-hook-setting-form': WebHookSettingForm,
    },
    data() {
      return {
        rules: {
          name: [
            {required: true, message: this.$t('Cuona.Event.description03'), trigger: 'blur'}
          ],
          url: [
            {validator: this.checkUrl, trigger: 'blur'}
          ],
          actionType: [
            {required: true, message: this.$t('Cuona.Event.description04'), trigger: 'change'}
          ]
        },
        dialogForm: {
          name: '',
          actionType: null,
          actionData: {},
          description: '',
          selectedGroupIds: [],
          selectedDevices: [],
        },
        groups: [],
        devices: [],
        availableActions: [],
        webhookSettings: {},
        isLoadingEvent: false,
        images:{
          empty: require('@/assets/empty_event.svg'),
          cube: require('@/assets/cuona_cube.svg'),
          tag: require('@/assets/cuona_seal.svg')
        },
        event: undefined
      }
    },
    mounted() {
      this.hideDialog();
    },
    computed: {
      isShowingDialog() {
        return this.$store.state.event_ui.showingEventDialog;
      },
      isEditing() {
        return !!this.eventId;
      },
      eventId() {
        return this.$store.state.event_ui.eventId;
      }
    },
    methods: {
      // イベント作成ダイアログを閉じた後の処理
      dialogClosed() {
        this.$refs.groupDeviceTable.clearSelection();
        this.dialogForm.name = '';
        this.dialogForm.actionType = null;
        this.dialogForm.description = '';
        this.dialogForm.selectedGroupIds = [];
        this.dialogForm.webhookSettings = {};
        this.dialogForm.actionData = {};
      },
      checkUrl(rule, value, callback) {
        if (!value || !value.match(/^(https?|ftp)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/)) {
          return callback(new Error(this.$t('Cuona.Event.description08')));
        } else {
          callback();
        }
      },
      setActionTitle() {
        const obj = this;
        if (this.dialogForm.actionType != null) {
          return this.$t(this.actions.find(function(e){return e.type === obj.dialogForm.actionType}).name);
        } else {
          return this.$t('Cuona.Event.action');
        }
      },
      setContent() {
        if (this.dialogForm.actionType != null) {
          return this.$t('Cuona.Event.'+this.dialogForm.actionType+"Explain");
        } else {
          return this.$t('Cuona.Event.actionExplain');
        }
      },
      // グループ作成時のCUONAのチェックをトグル
      toggleDevice: function(row, event, column) {
        this.$refs.groupDeviceTable.toggleRowSelection(row);
      },
      // グループ作成時にチェックされたCUONA一覧を取得
      setSelectedDevices(selectedDevices) {
        if (this.isLoadingEvent) {
          return;
        }
        let actionType = this.dialogForm.actionType;
        if(actionType !== 'public_url'){
          this.dialogForm.selectedDevices = selectedDevices;
          return;
        }
        // 共有イベントの場合、チェックしたCUONA内に共有設定が存在するかのチェック
        if(0 < selectedDevices.length) {
          let device = selectedDevices[selectedDevices.length-1];
          let checkHadPublicEvent = device.events.some(function(event){
            return event.action_type === 'public_url'
          });
          if(checkHadPublicEvent) {
            // 共有イベントの場合、以前の設定が削除される事がよいかの確認
            this.$confirm(this.$t('Cuona.Event.description12', {event_name:this.showEventName(actionType)}), this.$t('Cuona.Event.title06'), {
              dangerouslyUseHTMLString: true,
              confirmButtonText: 'OK',
              cancelButtonText: this.$t('Cuona.Event.cancel'),
              type: 'warning'
            }).then(() => {
              this.$message({
                type: 'success',
                message: this.$t('Cuona.Event.do_set_event')
              })
              this.dialogForm.selectedDevices = selectedDevices;
            }).catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('Cuona.Event.cancel_set_event')
              })
              this.$refs.groupDeviceTable.toggleRowSelection(device);
            });
          } else {
            this.dialogForm.selectedDevices = selectedDevices;
          }
        } else {
          this.dialogForm.selectedDevices = selectedDevices;
        }
      },
      // イベントの作成
      createUpdateEvent: function() {
        const that = this;
        this.$refs['dialogForm'].validate((valid) => {
          if (valid) {
            this.isLoadingEvent = true;
            const that = this;

            let pluginToken = null;
            let actionData = null;
            switch(this.dialogForm.actionType) {
              case 'public_url':
                actionData = {url: this.dialogForm.actionData.url};
                break;
              case 'custom_url':
                actionData = {url: this.dialogForm.actionData.url};
                break;
            }
            let webhook = undefined;
            if (this.dialogForm.actionType === 'checkin' || this.dialogForm.actionType === 'checkout') {
              webhook = {
                enabled: this.webhookSettings.enabled,
                url: this.webhookSettings.url,
                method: this.webhookSettings.method,
                headers: (this.webhookSettings.headers||[]).map(h=>{ return { name: h.key, value: h.value }}),
                body_type: this.webhookSettings.method === 'GET' ? 'none' : this.webhookSettings.body_type
              };
              if (webhook.body_type === 'form-data' || webhook.body_type === 'x-www-form-urlencoded') {
                webhook.body_params = (this.webhookSettings.body_params||[]).map(p=>{ return { name: p.key, value: p.value }});
              }
              if (webhook.body_type === 'raw') {
                webhook.raw_body = this.webhookSettings.raw_body;
              }
            }
            const params = {
              group_ids: this.dialogForm.selectedGroupIds,
              nfc_uids: this.selectedNfcUids(),
              plugin_token: pluginToken,
              event: {
                name: this.dialogForm.name,
                action_type: this.dialogForm.actionType,
                action_data: actionData,
                description: this.dialogForm.description,
                webhook: webhook
              }
            };
            const method = this.isEditing ? EventApi.updateEvent : EventApi.createEvent;
            const payload = this.isEditing ? { eventId: this.event.id, params } : params;
            method(payload)
              .then((events) => {
                this.events = events;
                this.hideDialog();
                this.$message({
                  showClose: true,
                  message: this.$t('Cuona.Event.description11'),
                  type: 'success'
                });
                this.$emit('eventUpdated');
              }).catch((error) => {
              let errorMessage = 'Cuona.Event.failed_create';
              switch(error.code) {
                case 409:
                  errorMessage = 'Cuona.Event.has_dup_name_event';
                  break;
              }
              const errorsArray = [];
              if (error.data && error.data.data && error.data.data.validation_errors) {
                for (const param of Object.keys(error.data.data.validation_errors)) {
                  for (const error_type of error.data.data.validation_errors[param]) {
                    errorsArray.push(`\n${`Cuona.Event.ValidationError.${param}.${error_type}`}`)
                  }
                }
              }
              this.$message({
                showClose: true,
                message: [errorMessage, ...errorsArray].map(m=>this.$t(m)).join('<br/>'),
                dangerouslyUseHTMLString: true,
                type: 'error'
              });
            }).finally(() => { this.isLoadingEvent = false; });
          } else {
            return false;
          }
        });
      },
      // イベント作成時に選択したデバイスID一覧
      selectedNfcUids: function() {
        return this.dialogForm.selectedDevices.map(function(selectedDevice) {
          return selectedDevice.nfc_uid;
        });
      },
      showDialog() {
        this.$store.dispatch('showEventDialog');
      },
      hideDialog() {
        this.$store.dispatch('hideEventDialog');
      },
      insertDeviceId() {
        this.dialogForm.actionData.url = this.dialogForm.actionData.url + "<<nfc_uid>>"
      },
      checkUrlLength() {
        return this.dialogForm.actionData.url === undefined ? true : false
      },
      getGroupsDevices() {
        const that = this;
        return Promise.all([DeviceApi.getDevices(), GroupApi.getGroups()])
          .then(function(values) {
            that.devices = values[0];
            that.groups = values[1];
          })
          .catch((error) => {
            this.$message({
              showClose: true,
              message: this.$t('Cuona.Event.failed_get'),
              type: 'error'
            })
          })
      },
      getPlugins() {
        PluginApi.getPlugins().then(plugins => {
          this.availableActions = this.getAvailableActions(plugins);
        }).catch(error => {
          console.error(error);
          this.$message.error(this.$t('user.loading_error'));
        });
      },
      // CUONAのアイコンを設定
      getCuonaImage: function(device) {
        if(device.is_development) {
          return this.images.dev;
        } else if(device.device_type === 'tag') {
          return this.images.tag;
        } else {
          return this.images.cube;
        }
      },
      clearEvent() {
        this.event = undefined;
        this.devices = undefined;
        this.groups = undefined;
      },
      getEvent(id) {
        const that = this;
        this.isLoadingEvent = true;
        return EventApi.getEvent(id).then(event => {
          that.event = event;
          that.dialogForm.name = event.name;
          that.dialogForm.actionType = event.action_type;
          that.dialogForm.actionData = event.action_data;
          that.dialogForm.description = event.description;
          this.dialogForm.selectedDevices = event.devices;
          let counter = 0;
          if (event.webhook) {
            that.webhookSettings = {
              enabled: event.webhook.enabled,
              method: event.webhook.method,
              url: event.webhook.url,
              headers: event.webhook.headers.map(h => ({key: h.name, value: h.value, id: counter++})),
              body_type: event.webhook.body_type,
              body_params: event.webhook.body_params
                ? event.webhook.body_params.map(p => ({key: p.name, value: p.value, id: counter++}))
                : [],
              raw_body: event.webhook.raw_body
            };
          } else {
            that.webhookSettings = { enabled: false }
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Event.failed_get'),
            type: 'error'
          });
        })
      },
      selectGroupsDevices() {
        this.dialogForm.selectedGroupIds = this.event.groups.map(g => g.id);
        this.dialogForm.selectedDevices = this.devices.filter(d => this.event.devices.some(ed => ed.id === d.id));
        this.$refs.groupDeviceTable.clearSelection();
        for (const device of this.dialogForm.selectedDevices) {
          this.$refs.groupDeviceTable.toggleRowSelection(device);
        }
      },
      showEventName: function(type) {
        let action = this.actions.filter(function(action) {
          return action.type === type;
        });
        return this.$t(action[0].name);
      },
    },
    watch: {
      isShowingDialog(val) {
        if (val) {
          this.isLoadingEvent = true;
          if (this.isEditing) {
            Promise.all([this.getGroupsDevices(), this.getEvent(this.eventId)])
              .then(() => this.selectGroupsDevices())
              .finally(() => { this.isLoadingEvent = false; })
          } else {
            Promise.all([this.getGroupsDevices(), this.getPlugins()])
              .finally(() => { this.isLoadingEvent = false; })
          }
        } else {
          this.clearEvent();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../styles/variables.scss";
  @import "../../../styles/table-layout.scss";

  button.question {
    padding: 0;
  }

  i.el-icon-question {
    font-size: 20px;
    color: #BBB;
    line-height: 20px;
    margin-left: 10px;
  }

  .group-select {
    width: 100%;
  }

  .el-dialog .content {
    margin: 0;
  }
</style>
